export enum ReportType {
  CLIPRO = 'CLIPRO',
  PGCSV = 'PGCSV',
  PGXLS = 'PGXLS',
  GNVERT = 'GNVERT'
}